import React, { useState } from "react";
import { toast } from "react-toastify";
import baseUrl from "../../../../../api/baseUrl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addPatientComplain } from "../../../../../redux/diagnosestate/diagnoseAction";
import { RootState } from "../../../../../redux/store";
interface FormData {
  description: string;
  toothNo: string;
}
function PatientComplain({ setmakeAction, makeAction }: any) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { ID } = useParams();
  const patientComplain = useSelector(
    (state: RootState) => state.diagnose.patientComplain
  );

  const [formData, setformData] = useState<FormData>({
    description: "",
    toothNo: "",
  });
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setformData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
     const response= await baseUrl.post("treatment/add-complain", formData, {
        headers: { treatmentid: ID },
      });
      
      dispatch(addPatientComplain(response.data.data));
      setformData({
        description: "",
        toothNo: "",
      })
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const remove = async (e: any) => {
    try {
      await baseUrl.post("treatment/remove-complain", formData, {
        headers: { treatmentid: ID, complainid: e._id },
      });
      setmakeAction(!makeAction);
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    }
  };
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-slate-200 dark:border-slate-700">
        <h4 className="text-sm font-bold text-slate-800 dark:text-slate-100">Patient Complaint</h4>
      </div>

      <div className="p-4">
        <form onSubmit={handleSubmit} className="flex flex-wrap gap-3 items-end mb-4">
          <div className="flex-1 min-w-[200px]">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Description *</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              placeholder="Enter complaint description"
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>
          <div className="w-32">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Tooth No</label>
            <input
              type="text"
              name="toothNo"
              value={formData.toothNo}
              onChange={handleChange}
              placeholder="e.g. 11"
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 rounded-lg bg-gradient-to-r from-rose-500 to-pink-600 text-white font-medium text-xs hover:shadow-lg hover:shadow-rose-200 transition-all disabled:opacity-50"
          >
            {isSubmitting ? "Adding..." : "Add"}
          </button>
        </form>

        {patientComplain.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 dark:bg-slate-700/50 border-b border-slate-100 dark:border-slate-600">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Description</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Tooth No</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase w-20">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
                {patientComplain.map((item: any, i: number) => (
                  <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
                    <td className="px-3 py-2 text-xs font-medium text-slate-800 dark:text-slate-200">{item.description}</td>
                    <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item.toothNo || "-"}</td>
                    <td className="px-3 py-2">
                      <button
                        onClick={() => remove(item)}
                        className="px-2.5 py-1 rounded-lg bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 hover:bg-red-200 dark:hover:bg-red-900/50 text-xs font-medium transition-colors"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {patientComplain.length === 0 && (
          <div className="text-center py-4 text-slate-400 dark:text-slate-500">
            <p className="text-xs">No complaints added yet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PatientComplain;
